import { rootMargin } from '@helpers/animate';
import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { highlightTitleWords } from '@helpers/utils';
import { useInView } from '@hooks/useInView';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './HeadingSummaryBlock.styles';
const HeadingSummaryBlock = (props) => {
    const [containerRef, inView] = useInView({ rootMargin }, false, props.pageContext?.isEditMode);
    if (!props.summary && !props.heading) {
        return null;
    }
    function hasContent() {
        return !!props.summary || (props.ctas && props.ctas.length > 0)
            || !!props.date || !!props.time
            || !!props.location || !!props.readTime;
    }
    return (React.createElement(S.Container, { ref: containerRef, "data-layout": props.layout ?? 'default', "data-animate": inView },
        React.createElement("div", null,
            props.headIcon && React.createElement(S.HeadIcon, null, getSvgIcon(props.headIcon)),
            props.subheading && React.createElement(S.Subheading, null, props.subheading),
            props.heading && (React.createElement(S.Heading, { as: props.headingType, dangerouslySetInnerHTML: { __html: highlightTitleWords(props.heading) } })),
            props.logoImage && (React.createElement(S.LogoImage, { src: props.logoImage.src, alt: props.logoImage.altText, loading: "lazy" }))),
        hasContent() ? (React.createElement(S.ContentWrapper, null,
            props.summary && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.summary } }),
            props.date || props.time || props.location || props.readTime ? (React.createElement(S.DetailContent, null,
                props.date && (React.createElement(S.Detail, null,
                    getSvgIcon(InterfaceIcon.CalendarBlank),
                    props.date)),
                props.time && (React.createElement(S.Detail, null,
                    getSvgIcon(InterfaceIcon.Clock),
                    props.time)),
                props.location && (React.createElement(S.Detail, null,
                    getSvgIcon(InterfaceIcon.Location),
                    props.location)),
                props.readTime && (React.createElement(S.Detail, null,
                    props.readTime,
                    " ",
                    props.translations?.['global.readtime.label'] ?? '')))) : null,
            props.ctas && props.ctas.length > 0 ? (React.createElement(S.ButtonWrapper, { "data-variant": props.ctaWrapperVariant }, props.ctas.map((cta, i) => (React.createElement(LinkButton, { key: `${cta.text}-${props.heading}-${i}`, buttonType: cta.buttonType ? cta.buttonType : 'primary', href: cta.url, target: cta.target, icon: cta.icon }, cta.text))))) : null)) : null));
};
export default HeadingSummaryBlock;
